import React from "react";
import classNames from "classnames/bind";

// component
import Map from "./Map";

import styles from "./CustomMap.module.scss";
const cx = classNames.bind(styles);

class CustomMapContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.refCount !== this.props.refCount) return true;

    return false;
  }

  render() {
    const { userCoords, events, direction, currentVisible, handleClick } =
      this.props;
    return (
      <div className={`${cx("map-container-root")} custom-map`}>
        {userCoords && (
          <Map
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            events={events}
            handleClick={handleClick}
            userCoords={userCoords}
            direction={direction}
            currentVisibleEvent={currentVisible}
          />
        )}
      </div>
    );
  }
}

export default CustomMapContainer;
